import { Roles } from "@outschool/auth-shared";
import { SERVICE_FEE_PERCENTAGE } from "@outschool/business-rules";
import { useIsEsaSessionPresent, useSession } from "@outschool/ui-auth";

export default function useEnrollmentServiceFee({
  isUsingPurchaseOrder = false,
  isUsingPricingOffer = false,
}: {
  isUsingPurchaseOrder?: boolean;
  isUsingPricingOffer?: boolean;
}) {
  const { currentUser } = useSession();
  const isESASession = useIsEsaSessionPresent();
  const isOrganizationAdminWhoCanEnroll =
    currentUser?.organizationAdmin &&
    currentUser?.roles?.includes(Roles.CanOrganizationEnroll);

  const showServiceFeePercentage =
    !isESASession &&
    !isUsingPurchaseOrder &&
    !isUsingPricingOffer &&
    !isOrganizationAdminWhoCanEnroll;

  return {
    serviceFeePercentage: showServiceFeePercentage ? SERVICE_FEE_PERCENTAGE : 0,
  };
}
